<cap-rubrik [id]="item.id" [isClosable]="item.isClosable" [isOpen]="item.isOpen">
  <ng-container title>
    <h2 class="mb-0">{{ item.title | translate }}</h2>
  </ng-container>
  @if (_standardrecht) {
    @switch (item.element) {
      @case ("detailStandardrechtBelastungen") {
        <cap-standardrecht-belastungen [recht]="_standardrecht"></cap-standardrecht-belastungen>
      }
      @case ("detailStandardrechtPerimeter") {
        <cap-recht-perimeter [perimeter]="_standardrecht.perimeter"></cap-recht-perimeter>
      }
      @case ("detailStandardrechtHaengigeGeschaefte") {
        <cap-haengige-geschaefte-auftraege [hasRight]="hasRight" [perimeter]="standardrechtPerimeter"></cap-haengige-geschaefte-auftraege>
      }
    }
  }
  @if (_pfandrecht) {
    @switch (item.element) {
      @case ("detailPfandrechtBelastungen") {
        <cap-pfandrecht-belastungen [recht]="_pfandrecht"></cap-pfandrecht-belastungen>
      }
      @case ("detailPfandrechtGlaeubiger") {
        <cap-pfandrecht-glaeubiger [recht]="_pfandrecht"></cap-pfandrecht-glaeubiger>
      }
      @case ("detailPfandrechtSchuldner") {
        <cap-pfandrecht-schuldner [recht]="_pfandrecht"></cap-pfandrecht-schuldner>
      }
      @case ("detailPfandrechtPfandtitel") {
        <cap-pfandrecht-capititel [recht]="_pfandrecht"></cap-pfandrecht-capititel>
      }
      @case ("detailPfandrechtPerimeter") {
        <cap-recht-perimeter [perimeter]="_pfandrecht.perimeter"></cap-recht-perimeter>
      }
      @case ("detailPfandrechtHaengigeGeschaefte") {
        <cap-haengige-geschaefte-auftraege [hasRight]="hasRight" [perimeter]="pfandrechtPerimeter"></cap-haengige-geschaefte-auftraege>
      }
    }
  }
</cap-rubrik>
